const KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "gclid",
  "fbclid",
  "ref",
  "campaign_id",
];

const STORE = "vila_attribution";

export const captureAttribution = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v;
    });
    if (Object.keys(found).length) {
      const existing = JSON.parse(sessionStorage.getItem(STORE) || "{}");
      sessionStorage.setItem(STORE, JSON.stringify({ ...existing, ...found }));
    }
  } catch (e) {
    /* ignore */
  }
};

export const getAttribution = () => {
  try {
    const stored = JSON.parse(sessionStorage.getItem(STORE) || "{}");
    const params = new URLSearchParams(window.location.search);
    KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) stored[k] = v;
    });
    return stored;
  } catch (e) {
    return {};
  }
};
